import './App.css';
import CharacterList from "./components/CharacterList.js"
function App() {
  return (
    <div className="App">
      <CharacterList />
    </div>
  );
}

export default App;
